import React from 'react'
import ConfirmDialog from 'components/ConfirmDialog'
import { observer } from 'mobx-react'

const RemoveLinkedAccountDialog = ({ dialog, account }) => (
  account && (
    <ConfirmDialog state={dialog} title="Removed Linked Account">
      Are you sure you want to remove your <strong>{account.institution}</strong> account?
    </ConfirmDialog>
  )
)

export default observer(RemoveLinkedAccountDialog)



// WEBPACK FOOTER //
// ./src/client/components/RemoveLinkedAccountDialog/index.jsx